import { render } from "./NoAdminUser.vue?vue&type=template&id=da8651e8&scoped=true"
import script from "./NoAdminUser.vue?vue&type=script&lang=js"
export * from "./NoAdminUser.vue?vue&type=script&lang=js"

import "./NoAdminUser.vue?vue&type=style&index=0&id=da8651e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da8651e8"]])

export default __exports__